// Cap for the diagnostic-only `ProStudioContext.errors` log. The array is never
// read or rendered anywhere in the machine — it only accumulates one entry per
// error event (API/validation failures, retries). Over a long, error-heavy
// session it grew without bound (PSTUDIO perf hygiene: a slow memory creep).
// Trimming the oldest entries is safe precisely because nothing consumes it.
export const MAX_TRACKED_ERRORS = 50;

/**
 * Append `error` to a bounded, in-place error log, dropping the oldest entries
 * once it exceeds {@link MAX_TRACKED_ERRORS}. No-op when the log is undefined.
 * Generic so it preserves the caller's element type — same type-safety as the
 * previous inline `errors?.push(error)`, just bounded.
 */
export function recordError<T>(errors: T[] | undefined, error: T): void {
  if (!errors) return;
  errors.push(error);
  if (errors.length > MAX_TRACKED_ERRORS) {
    errors.splice(0, errors.length - MAX_TRACKED_ERRORS);
  }
}
